import { render, staticRenderFns } from "./TensileTest.vue?vue&type=template&id=0c43ea9c&scoped=true&"
import script from "./TensileTest.vue?vue&type=script&lang=js&"
export * from "./TensileTest.vue?vue&type=script&lang=js&"
import style0 from "./TensileTest.vue?vue&type=style&index=0&id=0c43ea9c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c43ea9c",
  null
  
)

export default component.exports